import { useSidebar } from "../../context/SidebarContext";

export default function Backdrop() {
  const { isMobileOpen, closeSidebar } = useSidebar();

  if (!isMobileOpen) return null;

  return (
    <div
      className="fixed inset-0 top-16 bg-black/50 z-[55] lg:hidden"
      onClick={closeSidebar}
    />
  );
}
